<template>
  <div>
    <transition name="fade" :duration="{ enter: 1500, leave: 150 }">
      <section v-if="active == 'none'" class="services flex flex-between" key="none" style="animation-duration: 1.5s">
        <div class="card" @click="active = 'commercial'">
          <p class="title">
            {{ this.model.data.left_tile_title }}
          </p>
          <h2>{{ this.model.data.left_tile_headline }}</h2>
          <div class="circle"><img src="/images/services-circle.svg" alt=""></div>
        </div>
        <div class="card" @click="active = 'personal'">
          <p class="title">{{ this.model.data.right_tile_title }}</p>
          <h2>{{ this.model.data.right_tile_headline }}</h2>
          <div class="circle">
            <img src="/images/services-circle.svg" alt="">
          </div>
        </div>
      </section>
    </transition>
    <transition name="fadeLeft" leave-active-class="" :duration="{ enter: 1500, leave: 0 }">
      <section v-if="active == 'commercial'" class="detail-commercial" key="commercial" style="animation-duration: 1.5s">
        <div class="flex flex-between">
          <a class="close cursor-pointer" @click="active = 'none'">
            <img src="/images/x.svg" alt="">
          </a>
          <div class="heading">
            <p class="title">
              {{ this.model.data.left_tile_title }}
            </p>
            <h2>{{ this.model.data.left_tile_headline }}</h2>
          </div>
          <div class="wysiwyg" v-html="model.data.left_tile_content">
            
          </div>
        </div>
      </section>
      <section v-if="active == 'personal'" class="detail-personal" key="personal" style="animation-duration: 1.5s">
        <div class="flex flex-between">
          <a class="close cursor-pointer" @click="active = 'none'">
            <img src="/images/x.svg" alt="">
          </a>
          <div class="heading">
            <p class="title">
              {{ this.model.data.right_tile_title }}
            </p>
            <h2>{{ this.model.data.right_tile_headline }}</h2>
          </div>
          <div class="wysiwyg" v-html="model.data.right_tile_content">            
          </div>
        </div>
      </section>
    </transition>
  </div>
</template>

<script>
require('vue2-animate/dist/vue2-animate.min.css')

export default {
  props : [ 'model' ],
  data () {
    return {
      active: 'none',
    }
  }
}
</script>

<style>
.cursor-pointer {
  cursor: pointer;
}

section {
  animation-duration: 1s;
}
</style>


// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Services.vue